import React, { useMemo } from 'react'
import SonatypeLifecycleMappingForm, { STAGE_OPTIONS } from './SonatypeLifecycleMappingForm';
import SonatypeLifecycleCredentialsForm from './SonatypeLifecycleCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { CellRenderers } from 'utils/tableUtils';
import { split, find } from "utils/lodashUtils";
import { useFeatureFlag } from 'contexts/FeatureFlagContext';

export const formatSonatypeStage = (stage) =>  stage ? split(stage, ",").map(i => find(STAGE_OPTIONS, (opt) => opt.value === i)?.label).join() : CellRenderers.VALUE_OR_NA()

export default function SonatypeLifecycleConfigListing(props) {
    const featureFlags = useFeatureFlag();
    const columns =  useMemo(() => [{
        title: "Organization",
        dataIndex: "organisationName",
        width: 200
    },
    {
        title: "Application",
        dataIndex: "applicationName",
        width: 200
    }, 
    ...(featureFlags.NEXUS_LIFECYCLE_MULTI_STAGE_REPORT_SUPPORT ? [{
        title: "Stage",
        dataIndex: "stage",
        width: 200,
        render: formatSonatypeStage
    }] 
    : 
    [])
    ], [featureFlags.NEXUS_LIFECYCLE_MULTI_STAGE_REPORT_SUPPORT])
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            extraColumns={columns}
            MappingForm={SonatypeLifecycleMappingForm}
            CredentialsForm={SonatypeLifecycleCredentialsForm}
            triggerModifyParam={triggerModifyParam}
            displayComponentName="Organization"
        />
    )
};

const triggerModifyParam = (record) => {
    return {
        toolConfigId: record.id
    }
}